import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper';
import { useSiteContent } from '../../context/SiteContentContext';
import { getMediaUrl } from '../../services/api';

export default function BrandOne() {
    const { content } = useSiteContent();
    const section = content.certifications;
    if (!section?.items?.length) return null;

    const publicUrl = process.env.PUBLIC_URL + '/';
    return (
        <section className="brand-one-sec py-5">
            <div className="sec-title text-center">
                <div className="sec-title__tagline"><span className="left" /><h6>{section.subtitle}</h6><span className="right" /></div>
                <h2 className="sec-title__title" style={{ whiteSpace: 'pre-line' }}>{section.title}</h2>
            </div>
            <div className="brand-one__bg" style={{ backgroundImage: `url(${publicUrl}assets/images/backgrounds/brand-v1-bg.png)` }} />
            <div className="container">
                <Swiper
                    modules={[Autoplay, FreeMode]}
                    loop
                    spaceBetween={30}
                    slidesPerView={3}
                    speed={1400}
                    freeMode
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    breakpoints={{ 0: { slidesPerView: 1, spaceBetween: 20 }, 576: { slidesPerView: 2, spaceBetween: 30 }, 992: { slidesPerView: 3, spaceBetween: 40 } }}
                    className="thm-swiper__slider"
                >
                    {section.items.map((item, index) => <SwiperSlide key={item.name || index}>
                        <div className="brand-one__single p-2 bg-white rounded">
                            {item.image && <img className="img-fluid w-50" src={getMediaUrl(item.image)} alt={item.name} />}
                        </div>
                    </SwiperSlide>)}
                </Swiper>
            </div>
        </section>
    );
}
